import { Component, Prop, PropSync, Vue } from 'vue-property-decorator'
import {
    defaultSidebarTimeFilterOptions,
    defaultSidebarTimeFilterSelectedOption,
    SidebarTimeFilter,
    SidebarTimeFilterType
} from '@/components/sideBar/filters/time-filter/sidebar-filters-time-filter.model'

@Component
export default class SidebarFiltersTimeFilterExpanded extends Vue {
    @PropSync('selectedOption', { type: String })
    syncedSelectedOption!: SidebarTimeFilterType

    @Prop({ type: String, default: defaultSidebarTimeFilterSelectedOption })
    defaultOption!: SidebarTimeFilterType

    @Prop({ type: Array, default: () => defaultSidebarTimeFilterOptions() })
    options!: Array<SidebarTimeFilter>

    mounted(): void {
        if (!this.syncedSelectedOption) {
            this.syncedSelectedOption = this.defaultOption
        }
    }
}
